import { Action, configureStore, ThunkAction, combineReducers, AnyAction } from "@reduxjs/toolkit";
import {
    changePasswordReducer,
    activateAccountReducer,
    forgotPasswordReducer,
    registrationReducer,
    signInReducer,
} from "modules/auth";
import {
    activateUserReducer,
    updateRolesReducer,
    userActivityReducer,
    userAccountReducer,
    profileReducer,
    dashboardDataReducer,
    deactivateAccountReducer,
    addressReducer,
    singleUserActivityReducer,
} from "modules/dashboard";
import { moduleUsageDataReducer } from "modules/dashboard/store/userAdministration/moduleUsageDataSlice";
import {
    educationsReducer,
    expertAreasReducer,
    measuresReducer,
    operationTypesReducer,
    farmReducer,
} from "modules/education";
import { presentationsReducer } from "modules/presentation";
import { RootStateOrAny } from "react-redux";

export type AppDispatch = typeof store.dispatch;

const reducer = combineReducers({
    registration: registrationReducer,
    signIn: signInReducer,
    forgotPassword: forgotPasswordReducer,
    activateAccount: activateAccountReducer,
    changePassword: changePasswordReducer,
    userActivity: userActivityReducer,
    singleUserActivity: singleUserActivityReducer,
    userAccount: userAccountReducer,
    activateUser: activateUserReducer,
    updateRoles: updateRolesReducer,
    profile: profileReducer,
    address: addressReducer,
    dashboardData: dashboardDataReducer,
    moduleUsageData: moduleUsageDataReducer,
    deactivateAccount: deactivateAccountReducer,
    educations: educationsReducer,
    measures: measuresReducer,
    farmHolder: farmReducer,
    operationTypes: operationTypesReducer,
    expertAreas: expertAreasReducer,
    presentations: presentationsReducer,
});

const rootReducer = (state: RootStateOrAny, action: AnyAction) => {
    if (action.type === "SignIn/signOut") return reducer(undefined, action);
    return reducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV === "development",
});

export type RootState = ReturnType<typeof store.getState>;

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;
